import React, { useState, useEffect } from "react";
import Menubar from "../Menubar/Menubar";
import { Outlet, useParams } from "react-router-dom";
import "../Dashboard/Dashboard.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useLocation, useNavigate } from "react-router-dom";
const FeedbackForm = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const from = location.state?.from || "bookings"; // fallback
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
  // const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 1024);
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
    const savedState = localStorage.getItem("menubarOpen");

    if (savedState !== null) {
      return JSON.parse(savedState);
    }

    return window.innerWidth >= 1024;
  });
  const [feedbackExists, setFeedbackExists] = useState(false);
  //loader and navigate
  // const navigate = useNavigate();
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(true);
  //Form Logic
  const { bookingid } = useParams();

  console.log("Booking ID:", bookingid);

  const [formData, setFormData] = useState({
    bookingid: "",
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    city: "",
    property: "",
    firstexperince: "",
    learnofzorba: "",
    reservationhandled: "",
    cleanlinesshygiene: "",
    housekeepingservice: "",
    caretakersfriendliness: "",
    caretakerscompetence: "",
    qualityoftheservicesprovided: "",
    villaambience: "",
    villalocation: "",
    ratetheoveralistay: "",
    recommend: "",
    suggestions: "",
  });

  // responsive sidebar
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 1024;
      setIsMobile(mobile);

      if (mobile) {
        setIsSidebarOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Load booking or feedback
  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);
        const feedbackRes = await fetch(
          `https://demo.zorbastays.com/web-backend/feedback/${bookingid}`,
        );

        const feedbackData = await feedbackRes.json();

        console.log("Feedback API:", feedbackData);

        if (feedbackData && feedbackData.bookingid) {
          setFeedbackExists(true);

          // convert null values to ""
          const cleanedData = Object.fromEntries(
            Object.entries(feedbackData).map(([key, value]) => [
              key,
              value === null ? "" : value,
            ]),
          );

          setFormData((prev) => ({
            ...prev,
            ...cleanedData,
            bookingid,
          }));
        } else {
          setFeedbackExists(false);

          const bookingRes = await fetch(
            `https://demo.zorbastays.com/web-backend/booking/${bookingid}`,
          );

          const bookingData = await bookingRes.json();

          console.log("Booking API:", bookingData);

          setFormData((prev) => ({
            ...prev,
            bookingid,
            firstname: bookingData.firstname || "",
            lastname: bookingData.lastname || "",
            email: bookingData.email || "",
            phone: bookingData.phone || "",
            city: bookingData.city || "",
            property: bookingData.property || "",
          }));
        }
      } catch (error) {
        console.error("Load error:", error);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [bookingid]);

  // Handle form change
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Save feedback
  const handleSave = async () => {
    try {
      setSaving(true);
      if (feedbackExists) {
        await fetch(
          `https://demo.zorbastays.com/web-backend/feedback/${bookingid}`,
          {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(formData),
          },
        );
      } else {
        await fetch(`https://demo.zorbastays.com/web-backend/feedback`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        });
      }

      toast.success("Feedback saved successfully");
      setTimeout(() => {
        navigate(from === "reviews" ? "/reviews" : "/bookings");
      }, 1500);
    } catch (error) {
      console.error("Save error:", error);
    } finally {
      setSaving(false);
    }
  };
  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center bg-[#F8F9FA]">
        <div className="flex flex-col items-center gap-3">
          <div className="w-10 h-10 border-4 border-gray-300 border-t-green-700 rounded-full animate-spin"></div>
          <p className="text-gray-600 font-medium">Loading feedback form...</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />

      <div className="flex bg-[#F8F9FA]">
        <Menubar
          isOpen={isSidebarOpen}
          setIsOpen={setIsSidebarOpen}
          isMobile={isMobile}
        />

        <main
          className={`p-5 lg:p-6 transition-all duration-500 w-full ${
            isMobile ? "ml-0" : isSidebarOpen ? "ml-64" : "ml-16"
          }`}
        >
          <Outlet />

          {/* Header */}
          <div className="flex justify-between gap-5 items-start lg:items-center">
            <div className="flex flex-col lg:flex-row gap-5 items-start lg:items-center">
              <p className="font-semibold text-xl text-gray-700 ml-10 lg:ml-0">
                Feedback Form
              </p>
            </div>
          </div>
          {feedbackExists ? (
            <div className="bg-green-100 text-green-700 border p-2 rounded mb-4">
              Feedback already submitted
            </div>
          ) : (
            <div className="bg-red-100 text-red-700 border p-2 rounded mb-4">
              Feedback form not filled yet
            </div>
          )}
          {/* Form */}
          <div className="bg-white pt-3 p-5 border border-gray-200 rounded-md shadow-md mt-5">
            <div className="grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3 gap-x-5 gap-y-3">
              <div className="flex flex-col w-full">
                <label
                  for="input"
                  className="text-gray-400 text-sm font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
                >
                  First Name
                </label>
                <input
                  name="firstname"
                  value={formData.firstname}
                  onChange={handleChange}
                  placeholder="First Name"
                  className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                />
              </div>

              <div className="flex flex-col w-full">
                <label
                  for="input"
                  className="text-gray-400 text-sm font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
                >
                  Last Name
                </label>
                <input
                  name="lastname"
                  value={formData.lastname}
                  onChange={handleChange}
                  placeholder="Last Name"
                  className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                />
              </div>

              <div className="flex flex-col w-full">
                <label
                  for="input"
                  className="text-gray-400 text-sm font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
                >
                  Email
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Email"
                  className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                />
              </div>

              <div className="flex flex-col w-full">
                <label
                  for="input"
                  className="text-gray-400 text-sm font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
                >
                  Phone Number
                </label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Phone Number"
                  className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                />
              </div>

              <div className="flex flex-col w-full">
                <label
                  for="input"
                  className="text-gray-400 text-sm font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
                >
                  Place Of Residence
                </label>
                <input
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                  placeholder="Place of Residence"
                  className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                />
              </div>

              <div className="flex flex-col w-full">
                <label className="text-gray-400 text-sm font-semibold relative top-2 ml-2 px-1 bg-white w-fit z-10">
                  Was this your first experience with Zorba Stays?
                </label>

                <select
                  name="firstexperince"
                  value={formData.firstexperince || ""}
                  onChange={handleChange}
                  className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                >
                  <option value=""></option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>

              <div className="flex flex-col w-full">
                <label className="text-gray-400 text-sm font-semibold relative top-2 ml-2 px-1 bg-white w-fit z-10">
                  How did you learn of Zorba Stays?
                </label>

                <select
                  name="learnofzorba"
                  value={formData.learnofzorba || ""}
                  onChange={handleChange}
                  className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                >
                  <option value=""></option>
                  <option>Social Media</option>
                  <option>Friends</option>
                  <option>Family</option>
                  <option>Online Ads</option>
                  <option>Travel Website</option>
                  <option>Other</option>
                </select>
              </div>

              <div className="flex flex-col w-full">
                <label className="text-gray-400 text-sm font-semibold relative top-2 ml-2 px-1 bg-white w-fit z-10">
                  How was your Reservation Handled?
                </label>

                <select
                  name="reservationhandled"
                  value={formData.reservationhandled || ""}
                  onChange={handleChange}
                  className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                >
                  <option value=""></option>
                  <option>Excellent</option>
                  <option>Good</option>
                  <option>Average</option>
                  <option>Poor</option>
                </select>
              </div>

              <div className="flex flex-col w-full">
                <label className="text-gray-400 text-sm font-semibold relative top-2 ml-2 px-1 bg-white w-fit z-10">
                  Select the Property you stayed in?
                </label>

                {/* <select className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md">
                <option value=""></option>
                <option>Property 1</option>
                <option>Property 2</option>
                <option>Property 3</option>
              </select> */}

                <input
                  name="property"
                  value={formData.property}
                  onChange={handleChange}
                  placeholder="Property Name"
                  className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                />
              </div>

              <div className="flex flex-col w-full">
                <label className="text-gray-400 text-sm font-semibold relative top-2 ml-2 px-1 bg-white w-fit z-10">
                  How would you rate the overall stay?
                </label>

                <select
                  name="ratetheoveralistay"
                  value={formData.ratetheoveralistay || ""}
                  onChange={handleChange}
                  className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                >
                  <option value=""></option>
                  <option>Excellent</option>
                  <option>Good</option>
                  <option>Average</option>
                  <option>Poor</option>
                </select>
              </div>

              <div className="flex flex-col w-full">
                <label className="text-gray-400 text-sm font-semibold relative top-2 mx-2 px-1 bg-white w-fit z-10">
                  How would you rate the
                  <b className="text-gray-500"> Cleanliness and Hygiene </b> at
                  Zorba Stays?
                </label>

                <select
                  name="cleanlinesshygiene"
                  value={formData.cleanlinesshygiene || ""}
                  onChange={handleChange}
                  className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                >
                  <option value=""></option>
                  <option>Excellent</option>
                  <option>Good</option>
                  <option>Average</option>
                  <option>Poor</option>
                </select>
              </div>

              <div className="flex flex-col w-full">
                <label className="text-gray-400 text-sm font-semibold relative top-2 mx-2 px-1 bg-white w-fit z-10">
                  How would you rate the
                  <b className="text-gray-500"> Housekeeping Service </b> at
                  Zorba Stays?
                </label>

                <select
                  name="housekeepingservice"
                  value={formData.housekeepingservice || ""}
                  onChange={handleChange}
                  className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                >
                  <option value=""></option>
                  <option>Excellent</option>
                  <option>Good</option>
                  <option>Average</option>
                  <option>Poor</option>
                </select>
              </div>

              <div className="flex flex-col w-full">
                <label className="text-gray-400 text-sm font-semibold relative top-2 mx-2 px-1 bg-white w-fit z-10">
                  How would you rate the
                  <b className="text-gray-500"> Caretaker's Friendliness </b> at
                  Zorba Stays?
                </label>

                <select
                  name="caretakersfriendliness"
                  value={formData.caretakersfriendliness || ""}
                  onChange={handleChange}
                  className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                >
                  <option value=""></option>
                  <option>Excellent</option>
                  <option>Good</option>
                  <option>Average</option>
                  <option>Poor</option>
                </select>
              </div>

              <div className="flex flex-col w-full">
                <label className="text-gray-400 text-sm font-semibold relative top-2 mx-2 px-1 bg-white w-fit z-10">
                  How would you rate the
                  <b className="text-gray-500"> Caretaker's Competence </b> at
                  Zorba Stays?
                </label>

                <select
                  name="caretakerscompetence"
                  value={formData.caretakerscompetence || ""}
                  onChange={handleChange}
                  className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                >
                  <option value=""></option>
                  <option>Excellent</option>
                  <option>Good</option>
                  <option>Average</option>
                  <option>Poor</option>
                </select>
              </div>

              <div className="flex flex-col w-full">
                <label className="text-gray-400 text-sm font-semibold relative top-2 mx-2 px-1 bg-white w-fit z-10">
                  How would you rate
                  <b className="text-gray-500">
                    {" "}
                    Quality of the Services Provided{" "}
                  </b>{" "}
                  at Zorba Stays?
                </label>

                <select
                  name="qualityoftheservicesprovided"
                  value={formData.qualityoftheservicesprovided || ""}
                  onChange={handleChange}
                  className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                >
                  <option value=""></option>
                  <option>Excellent</option>
                  <option>Good</option>
                  <option>Average</option>
                  <option>Poor</option>
                </select>
              </div>

              <div className="flex flex-col w-full">
                <label className="text-gray-400 text-sm font-semibold relative top-2 mx-2 px-1 bg-white w-fit z-10">
                  How would you rate the
                  <b className="text-gray-500"> Property Ambience </b> at Zorba
                  Stays?
                </label>

                <select
                  name="villaambience"
                  value={formData.villaambience || ""}
                  onChange={handleChange}
                  className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                >
                  <option value=""></option>
                  <option>Excellent</option>
                  <option>Good</option>
                  <option>Average</option>
                  <option>Poor</option>
                </select>
              </div>

              <div className="flex flex-col w-full">
                <label className="text-gray-400 text-sm font-semibold relative top-2 mx-2 px-1 bg-white w-fit z-10">
                  How would you rate the
                  <b className="text-gray-500"> Property Location </b> at Zorba
                  Stays?
                </label>

                <select
                  name="villalocation"
                  value={formData.villalocation || ""}
                  onChange={handleChange}
                  className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                >
                  <option value=""></option>
                  <option>Excellent</option>
                  <option>Good</option>
                  <option>Average</option>
                  <option>Poor</option>
                </select>
              </div>

              <div className="flex flex-col w-full">
                <label className="text-gray-400 text-sm font-semibold relative top-2 ml-2 px-1 bg-white w-fit z-10">
                  Would you recommend Zorba Stays to friends or family?
                </label>

                <select
                  name="recommend"
                  value={formData.recommend || ""}
                  onChange={handleChange}
                  className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                >
                  <option value=""></option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>

              <div className="flex flex-col w-full lg:col-span-2 2xl:col-span-3">
                <label
                  for="input"
                  className="text-gray-400 text-sm font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
                >
                  Do you have any suggestions for improvements or areas that
                  could be enhanced?
                </label>
                <textarea
                  name="suggestions"
                  value={formData.suggestions || ""}
                  onChange={handleChange}
                  className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                />
              </div>
            </div>
          </div>

          <div className="grid grid-cols-2 justify-self-center gap-3 w-80 my-8">
            <button
              onClick={() =>
                navigate(from === "reviews" ? "/reviews" : "/bookings")
              }
              className="px-6 z-30 py-2 bg-gray-800 rounded-lg text-center text-white relative hover:scale-95 after:-z-20 after:absolute after:h-1 after:w-1 after:bg-gray-700 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700 transition-all duration-700 text-sm"
            >
              Cancel
            </button>

            <button
              onClick={handleSave}
              disabled={saving}
              className="px-6 z-30 py-2 bg-green-900 rounded-lg text-center text-white relative hover:scale-95 after:-z-20 after:absolute after:h-1 after:w-1 after:bg-green-700 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700 transition-all duration-700 text-sm"
            >
              {saving ? "Saving..." : "Save"}
            </button>
          </div>
        </main>
      </div>
    </>
  );
};

export default FeedbackForm;
